import { render, staticRenderFns } from "./PaymentCollectionReport.vue?vue&type=template&id=7a6d23d0&scoped=true"
import script from "./PaymentCollectionReport.vue?vue&type=script&lang=js"
export * from "./PaymentCollectionReport.vue?vue&type=script&lang=js"
import style0 from "./PaymentCollectionReport.vue?vue&type=style&index=0&id=7a6d23d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6d23d0",
  null
  
)

export default component.exports